// extracted by mini-css-extract-plugin
module.exports = {"c-carousel":"base-carousel_c-carousel__rmzVn","carousel-header-container":"base-carousel_carousel-header-container__Hi_jY","heading":"base-carousel_heading__V7Eyt"};